import { render, staticRenderFns } from "./NextMatchdayGamesWidget.vue?vue&type=template&id=729d7370"
import script from "./NextMatchdayGamesWidget.vue?vue&type=script&lang=js"
export * from "./NextMatchdayGamesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports